<template>
	<div class="loginBody">
			<div class="loginPanel">
				<div class="loginTit">
					<div class="ucLogo">
						<img src="../../assets/images/logo_ucenter.png" />
					</div>
					<p>安仔远程运维服务</p>
				</div>
				<div class="loginForm">
					<div class="itemCell">
						<div class="itemImg">
							<div class="itemImg01"></div>
						</div>
						<div class="fenge"></div>
						<div class="itemIpu">
							<input type="text" placeholder="请输入账号" v-model="userName" autocomplete="off"/>
						</div>
					</div>
					<div class="itemCell">
						<div class="itemImg">
							<div class="itemImg02"></div>
						</div>
						<div class="fenge"></div>
						<div class="itemIpu">
							<input type="password" placeholder="请输入密码" v-model="passWord" autocomplete="off"/>
						</div>
					</div>
					<div class="itemCell">
						<div class="itemImg">
							<div class="itemImg03"></div>
						</div>
						<div class="fenge"></div>
						<!--<div class="itemIpu" v-if="isShowType">
							<input type="text" placeholder="选择类型" @click="isShow"/>
							
						</div>-->
						<div class="itemIpu">
							<input type="text" id="picker" v-bind:value="checkItem" placeholder="选择类型" @click="popupVisible = true" readonly="readonly"/>
						</div>
					</div>
					
				</div>
				<div class="loginBtn" @click="login">
					登录
				</div>
			</div>
			<mt-popup
			  v-model="popupVisible" ref="picker"
			  popup-transition="popup-fade" position="bottom" class="">
			  <mt-picker :slots="dateSlots" @change="onChange" :visible-item-count="3" :show-toolbar="true">
			  	<mt-button @click="handleCancel" class="cancel">取消</mt-button>
			  	<mt-button @click="handleConfirm" class="sure">确认</mt-button>
			  </mt-picker>
			</mt-popup>
		</div>
		
</template>

<script>
	import {_api} from '@/service/interface'
	import { Toast } from 'mint-ui';
	import apiConfig from '@/service/url'
	export default{
		name: 'Login',
		data(){
			return {
				loginUrl:'/point',
				popupVisible:false,
				dateSlots:[
					{
						flex:1,
						values:['行业客户','合作伙伴'],
						className:'slot1',
						textAlign:'center',
						defaultIndex:0
					}
				],
				userName:'',
				passWord:'',
				checkType:'',
				orangialIndex:0,
				checkItem:'',
				termType:'',
				duration:3000,
				position:'bottom'
			}
		},
		watch:{
			
		},
		methods:{
			onChange(picker,values){
				this.checkType = values[0];
				//this.checkItem = picker.getSlotValue(0);
			},
			handleCancel(event){
				//this.$refs.picker.close();
				this.popupVisible=false;
			},
			handleConfirm(event){
				this.checkItem = this.checkType;
				this.popupVisible=false;
			},
			login(event){
				this.termType={"行业客户":'industry',"合作伙伴":'agency',"渠道客户":'channel'}[this.checkItem];
				if(!this.userName){
					Toast({
					  message: '请输入用户名',
					  position: this.position,
					  duration: this.duration
					});
					return;
				}
				if(!this.passWord){
					Toast({
					  message: '请输入密码',
					   position: this.position,
					  duration: this.duration
					});
					return;
				}
				if(!this.termType){
					Toast({
					  message: '请选择用户类型',
					  position: this.position,
					  duration: this.duration
					});
					return;
				}
				 _api('_login','.code',{userName:this.userName,passWord:this.passWord,termType:this.termType},data=>{
					if(data.message=='/gzyl/view/gzyl.html'){
						window.location.href=apiConfig.baseURL+data.message
					} else {
						sessionStorage.setItem("termType",this.termType)
				 		this.$router.push(this.loginUrl)
					}					
				 },err=>{
				 	
				 })
				
			}
		},
		mounted(){
			//this.buttonBottom = this.$refs.button.$el.getBoundingClientRect().bottom;
		}
	}
</script>
<style scoped>
	@import '../../assets/css/style-login.css'
</style>
<style>
	.mint-popup{
		width:101%;
	}
	.picker-toolbar{
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #DBDBDB;
	}
	.inputMark{
		width: 200px;
		height: 30px;
		background: transparent;
		position: absolute;
	}
	.cancel {
		border: none;
		background: transparent;
		box-shadow: none;
		color: #474747;
		font-size: 16px;
		padding: 0 15px;
	}
	.sure {
		border: none;
		background: transparent;
		box-shadow: none;
		color: #039FC5;
		font-size: 16px;
		padding: 0 15px;
	}
	
	.picker-slot{
		z-index: 9;
	}
	.picker-item{
		color: #58BBD8;
		background-image: linear-gradient(bottom,#7AD2EA,#0F9AD1);
		background-image: -webkit-linear-gradient(bottom,#7AD2EA,#0F9AD1);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-size: 16px;
		font-weight: 700;
	}
	.picker-item.picker-selected{
		color: #006E89;
		background-image: linear-gradient(bottom,#006E89,#006E89);
		background-image: -webkit-linear-gradient(bottom,#006E89,#006E89);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	.picker-center-highlight{
		background-image: linear-gradient(left,#C1E7E8,#C3E1EB) ;
		background-image: -webkit-linear-gradient(left,#C1E7E8,#C3E1EB) ;
	}
	
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue